import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RootRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      // If authenticated, redirect to roles page
      navigate('/roles');
    } else {
      // If not authenticated, redirect to login
      navigate('/login');
    }
  }, [navigate]);

  // Show loading while redirecting
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="flex items-center space-x-2">
        <div className="w-6 h-6 border-2 border-[#02B491] border-t-transparent rounded-full animate-spin"></div>
        <span className="text-gray-600">Loading...</span>
      </div>
    </div>
  );
};

export default RootRedirect; 